import { render, staticRenderFns } from "./UpdateSupplierPage.vue?vue&type=template&id=2fc85181"
import script from "./UpdateSupplierPage.vue?vue&type=script&lang=js"
export * from "./UpdateSupplierPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports